import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerServiceProxy, FilterModel, OrderFilterModel, OrderModel, OrderServiceProxy, OrderStatus, PaymentModel, PaymentType, SubscriptionFilter, SubscriptionModel, SubscriptionServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { takeUntil } from 'rxjs';
import { TableColumn } from '../../../interfaces/table-column.interface';
import { ErrorService } from '../../../services/error/error.service';
@Component({
    selector: 'app-customer-page',
    templateUrl: './customer-page.component.html',
    styleUrl: './customer-page.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class CustomerPageComponent implements OnInit {

  currentPage: number = 1;
  pageSize: number = 3;
  totalItems: number = 0;
  orderPagination = {
    currentPage: this.currentPage,
    pageSize: this.pageSize,
    totalItems: this.totalItems
  }
  subscriptionPagination = {
    currentPage: this.currentPage,
    pageSize: this.pageSize,
    totalItems: this.totalItems
  }
  paymentPagination = {
    currentPage: this.currentPage,
    pageSize: this.pageSize,
    totalItems: this.totalItems
  }
  public orderFilter: OrderFilterModel = new OrderFilterModel();
  public orders: OrderModel[] = [];

  public customerId: string = '';

  dataMissingOrders: boolean | string = false || '';
  dataMissingSubscriptions: boolean | string = false || '';
  dataMissingPayment: boolean|string = false || '';

  public columnsOrders: TableColumn[] = [
    { header: 'Заказ', field: 'code', col: 5 },
    { header: 'Сумма', field: 'total', col: 5 },
    { header: 'Дата', field: 'createdAt', col: 5 },
    { header: 'Пользователь', fields: ['user.firstname', 'user.lastname'], col: 5 },
    { header: '', field: 'status', col: 4, isPagination: true },
  ];

  public subscriptionsFilter: SubscriptionFilter  = new SubscriptionFilter();
  public subscriptions: SubscriptionModel[] = [];
  public columnsSubscription: TableColumn[] = [
    { header: 'Логин', field: 'login', col: 2, isCopyable: true },
    { header: 'Пароль', field: 'password', col: 2, isCopyable: true },
    { header: 'Товар', field: 'orderProduct.name', col: 3 },
    { header: 'Цена', field: 'orderProduct.price', col: 2 },
    { header: 'Создан', field: 'createdAt', col: 3 },
    { header: 'Активирован', field: 'activatedAt', col: 3 },
    { header: 'Заканчивается', field: 'expiresAt', col: 3 },
    { header: 'Смотрел', field: 'lastSeenAt', col: 4 },
    { header: '', field: 'isActive', col: 3, },
    { header: '', field: 'btnProlong', col: 3, isPagination: true },
  ];

  public paymentFilter: FilterModel = new FilterModel();
  public payment: PaymentModel[] = [];

  isLoading: boolean = true;
  countSkeleton: number = 3;

  public columnsPayment: TableColumn[] = [
    { header: 'ID', field: 'transactionId', col: 3 },
    { header: 'Сумма', field: 'amount', col: 3 },
    { header: 'Товар', field: 'productName', col: 5 },
    { header: 'Дата платежа', field: 'createdAt', col: 5 },
    { header: 'Пользователь', field: 'createdById', col: 5 },
    { header: '', field: 'type', col: 3, isPagination: true },
  ];

  public heightTable = {
    heightTable: 'auto',
    heightBody: '150px'
  }

  constructor(private route: ActivatedRoute, private _customerService: CustomerServiceProxy,
    private _orderService: OrderServiceProxy, private destroyService: DestroyService, private errorService: ErrorService) {
  }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.destroyService.onDestroy$)).subscribe(params => {
      this.customerId = params.get('id') || ''; 

      this.getOrders();
      this.getSubscriptions();
      this.getPayments();
    });
  }
 
  getOrders() {
    this.orderFilter.customerId = this.customerId;
    this.orderFilter.page = this.orderPagination.currentPage;
    this.orderFilter.perPage = this.orderPagination.pageSize;
    this._orderService.getByFilter(this.orderFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe((orders) => {
        this.orders = orders.items;
        this.orderPagination.totalItems = orders.total;
        this.isLoading = false;
        this.dataMissingOrders = this.orders.length == 0;
        console.log(orders);
    }, error => {
        console.error(error);
        this.dataMissingOrders = 'Не удалось получить заказы клиента. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить заказы клиента. Попробуйте позже.');
    })
  }

  getSubscriptions() {
    this._customerService.getSubscriptions(this.customerId, new FilterModel({page:this.subscriptionPagination.currentPage, perPage:this.subscriptionPagination.pageSize}))
    .pipe(takeUntil(this.destroyService.onDestroy$))
    .subscribe(subscriptions => {
      this.subscriptions = subscriptions.items;
      this.subscriptionPagination.totalItems = subscriptions.total;
      console.log(subscriptions);
      this.isLoading = false;
      this.dataMissingSubscriptions = this.subscriptions.length == 0;
    }, error => {
      console.log(error);
      this.isLoading = false;
      this.dataMissingSubscriptions = 'Не удалось получить подписки клиента. Попробуйте позже.';
      this.errorService.handleError(error, 'Не удалось получить подписки клиента. Попробуйте позже.');
    })
  }

  getPayments() {
    this.paymentFilter.page = this.paymentPagination.currentPage;
    this.paymentFilter.perPage = this.paymentPagination.pageSize;
    this._customerService.getPayments(this.customerId, this.paymentFilter)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(payment => {
        var temp = payment.items;
        var payments = [];
        this.paymentPagination.totalItems = payment.total;
        temp.forEach(p => {
          p.transactionId = p.transactionId ? p.transactionId : p.id;

          p.createdById = p.user ? p.user.firstname + " " + p.user.lastname : p.createdById;
          
          if (p.type == PaymentType.NewOrder || p.type == PaymentType.Refund) {
            this.columnsPayment[2].field = 'order.code';
          } else {
            this.columnsPayment[2].field = 'orderProduct.name';
          }
          payments.push(p);
        })
        this.payment = payments;
        this.isLoading = false;

        console.log(payment);
        this.dataMissingPayment = this.payment.length == 0;
        
      }, error => {
        console.error(error);
        this.isLoading = false;
        this.dataMissingPayment = 'Не удалось получить платежи. Попробуйте позже.'
        this.errorService.handleError(error, 'Не удалось получить платежи. Попробуйте позже.');
    })
  }

  getOrderStatuses(status: OrderStatus): string {
    switch (status) {
      case OrderStatus.Draft:
        return "Черновик";
      case OrderStatus.New:
        return "Новый";
      case OrderStatus.Paid:
        return "Оплаченный";
      case OrderStatus.Processing:
        return "В обработке";  
      case OrderStatus.Completed:
        return "Завершенный";
      case OrderStatus.Cancelled:
        return "Отмененный";
      default:
        return "Неизвестный";
    }
  }

  getPaymentsType(type: PaymentType): string {
    switch (type) {
      case PaymentType.NewOrder:
        return "Новый заказ";
      case PaymentType.AdditionalProduct:
        return "Дополнительный товар";
      case PaymentType.RecurringPayment:
        return "Повторяющийся платеж";
      case PaymentType.Other:
        return "Другое";  
      case PaymentType.Refund:
        return "Возврат";
      case PaymentType.PartialRefund:
        return "Частичный возврат";
      default:
        return "Неизвестный";
    }
  }

  onPageChangeOrders(newPage: number) {
    this.orderPagination.currentPage = newPage;
    this.getOrders();
  }
  onPageChangeSubscriptions(newPage: number) {
    this.subscriptionPagination.currentPage = newPage;
    this.getSubscriptions();
  }
  onPageChangePayments(newPage: number) {
    this.paymentPagination.currentPage = newPage;
    this.getPayments();
  }

} 
